import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Download, Share } from "lucide-react";
import { Button } from "@/components/ui/button";
import { isIOS, isStandalone } from "@/pwa/pushClient";

export const InstallAppHint = () => {
  const { t } = useTranslation();
  const [prompt, setPrompt] = useState(null);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  if (isStandalone()) return null;

  if (isIOS()) {
    return (
      <div data-testid="phone-alerts-ios-hint" className="flex gap-2 rounded-sm border border-amber-200 bg-amber-50 p-3 text-xs text-amber-900">
        <Share className="w-4 h-4 shrink-0 mt-0.5" /> <span>{t("phoneAlerts.iosInstall")}</span>
      </div>
    );
  }

  if (!prompt) return null;
  const install = async () => { prompt.prompt(); await prompt.userChoice; setPrompt(null); };
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 rounded-sm border border-slate-200 bg-slate-50 p-3 text-xs text-slate-700">
      <span>{t("phoneAlerts.androidInstall")}</span>
      <Button data-testid="phone-alerts-install-button" size="sm" variant="outline" className="rounded-sm" onClick={install}>
        <Download className="w-3.5 h-3.5 mr-1.5" /> {t("phoneAlerts.installButton")}
      </Button>
    </div>
  );
};
